import { ZodTypeAny } from "zod";

export type RouteTree = {
  [key: string]: Route | RouteTree;
};

export enum HttpMethodEnum {
  GET = "get",
  POST = "post",
  PUT = "put",
  DELETE = "delete",
  PATCH = "patch",
}

export enum HttpParamsTypeEnum {
  QUERY = "query",
  BODY = "body",
}

export interface Route {
  method: HttpMethodEnum;
  paramsType?: HttpParamsTypeEnum;
  requestZodSchema?: ZodTypeAny;
  responseZodSchema: ZodTypeAny;
}

// Helper function to determine if something is a route-info object
export function isRoute(obj: any): obj is Route {
  return obj && typeof obj.method === "string";
}
